import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="bg-burgundy py-10 px-6 md:py-16" data-id="element-227">
      <div className="max-w-3xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-5 text-lg leading-relaxed text-cream" data-id="element-229">
          <p data-id="element-230">
            Tu te lèves avant tout le monde. Les lunchs. Les conflits. Les
            messages de l'ex. Tu souris à tout le monde.
          </p>

          <p className="text-xl font-semibold" data-id="element-231">
            Et le soir... il ne reste plus rien pour toi.
          </p>

          <div className="space-y-3 py-2" data-id="element-232">
            <p data-id="element-233">
              <span className="mr-2" data-id="element-234">❌</span>Plus d'énergie
            </p>
            <p data-id="element-235">
              <span className="mr-2" data-id="element-236">❌</span>Plus de joie
            </p>
            <p data-id="element-237">
              <span className="mr-2" data-id="element-238">❌</span>Tu culpabilises même d'avoir envie
              de te retrouver
            </p>
          </div>

          <blockquote className="font-playfair italic text-xl md:text-2xl text-gold border-l-4 border-gold pl-5 py-3" data-id="element-239">
            "Être une bonne maman ne devrait jamais signifier s'effacer
            complètement en tant que femme."
          </blockquote>

          <p className="text-2xl font-playfair text-cream font-semibold pt-2" data-id="element-240">
            Ce mensonge t'a déjà coûté assez cher.
          </p>
        </motion.div>
      </div>
    </section>;
}